import React from 'react';
import Preloader from '../images/preloader.gif'
class GrowExample extends React.Component {
  render() {
    return <img className='pre-loader' src={Preloader} alt='loader'/>;
  }
}

export default GrowExample;